import { Module } from "@/modules/tenantAdmin/enums";

export default [
  {
    path: "/klanten",
    component: () => import("@/application/layouts/KSplitView.vue"),
    meta: {
      module: Module.Customer,
    },
    children: [
      {
        path: "",
        name: "customer.index",
        components: {
          index: () =>
            import("@/modules/tenantAdmin/customer/views/CustomerTable.vue"),
          details: () =>
            import("@/modules/tenantAdmin/customer/views/CustomerEmptyDetails.vue"),
        },
      },
      {
        path: ":customerId",
        name: "customer.index.details",
        components: {
          index: () =>
            import("@/modules/tenantAdmin/customer/views/CustomerTable.vue"),
          details: () =>
            import("@/modules/tenantAdmin/customer/views/CustomerDetails.vue"),
        },
      },
    ],
  },
];
